import { render, staticRenderFns } from "./RelicMessage.vue?vue&type=template&id=1f14acc7"
import script from "./RelicMessage.vue?vue&type=script&lang=js"
export * from "./RelicMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports